import React from "react";
import { motion } from "framer-motion";
import { Package, Box, Boxes, Truck, Layers } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { Seo } from "../components/Seo";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { IMAGES } from "../data/content";

const STEPS = [
  { icon: Boxes, de: { t: "Big Bag", d: "Großgebinde für effiziente Mengen." }, en: { t: "Big Bag", d: "Bulk packaging for efficient volumes." } },
  { icon: Box, de: { t: "Octabin", d: "Stabile Schüttgut-Verpackung." }, en: { t: "Octabin", d: "Stable bulk packaging." } },
  { icon: Package, de: { t: "25-kg-Säcke", d: "Flexible Kleingebinde." }, en: { t: "25 kg sacks", d: "Flexible small packaging." } },
  { icon: Layers, de: { t: "Palettiert", d: "Sicher gestapelt und gesichert." }, en: { t: "Palletized", d: "Safely stacked and secured." } },
  { icon: Truck, de: { t: "Transport", d: "Zuverlässige Lieferung weltweit." }, en: { t: "Transport", d: "Reliable delivery worldwide." } },
];

export default function Logistics() {
  const { t, lang, pick } = useLang();
  return (
    <>
      <Seo title="Logistik & Verpackung – Big Bag, Octabin, Säcke | PlastoNord"
        description="Effiziente Logistik von PlastoNord: Big Bag, Octabin, 25-kg-Säcke, palettierte Lieferung und Transport. Zuverlässige Versorgung mit Kunststoffgranulat weltweit."
        path="/logistik" />
      <PageHero overline={t("nav.logistics")}
        title={lang === "de" ? "Zuverlässige Versorgung – richtig verpackt" : "Reliable supply – properly packaged"}
        subtitle={lang === "de" ? "Vom Big Bag bis zum 25-kg-Sack: passende Gebinde und planbare Lieferungen für Ihre Produktion." : "From big bag to 25 kg sack: suitable packaging and predictable deliveries for your production."} />
      <section className="py-24">
        <div className="pn-container">
          <div className="relative grid gap-6 md:grid-cols-5">
            <div className="absolute left-0 right-0 top-7 hidden h-px bg-[#e4e9f0] md:block" />
            {STEPS.map((s, i) => { const c = pick(s); return (
              <motion.div key={c.t} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.12, duration: 0.5 }} className="relative text-center">
                <span className="relative z-10 mx-auto grid h-14 w-14 place-items-center rounded-full border border-[#e4e9f0] bg-white text-[#16181D] shadow-sm"><s.icon size={22} /></span>
                <h3 className="mt-4 font-head text-base font-semibold text-[#16181D]">{c.t}</h3>
                <p className="mt-1 text-sm text-[#4a4d52]">{c.d}</p>
              </motion.div>
            ); })}
          </div>
          <Reveal delay={0.1}>
            <img src={IMAGES.facility} alt="Lager und Logistik für Kunststoffgranulat bei PlastoNord" className="mt-16 w-full rounded-2xl border border-[#e4e9f0] shadow-xl" loading="lazy" />
          </Reveal>
        </div>
      </section>
    </>
  );
}
